export default {
  name: 'edit',
  path: '/edit/:id',
  loadComponent: () => import('./index')
};
